import styled from 'styled-components';
import { fontFamilyVariables, fontVariables, mediaTemplates } from 'theme/variables';

export const VideoInfoHeaderStyled = styled.div`
  font-family: ${fontFamilyVariables.din_regular};
`;

export const TitleWrap = styled.div`
  width: 100%;
  color: #333;

  h3 {
    max-height: 70px;
    min-height: 32px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    ${mediaTemplates.l} {
      font-size: ${fontVariables.fs_xxxl};
    }
  }
`;

export const Extra = styled.div`
  margin-top: 6px;
  margin-bottom: 3px;

  ${mediaTemplates.l} {
    font-size: ${fontVariables.s};
    margin-top: 15px;
  }
`;

export const SaleModel = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SaleModelWrap = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const SaleModelInnerWrap = styled.div`
  display: flex;
  align-items: center;
  height: 13px;
  ${mediaTemplates.l} {
    height: 14px;
  }

  &:not(:first-child) {
    margin-left: 8px;
  }
`;

export const IconWrap = styled.div`
  margin-right: 2px;
  font-size: 0;
`;

export const TextWrap = styled.div`
  height: 15px;
  line-height: 1;

  ${mediaTemplates.l} {
    height: 14px;
  }
`;

export const SaleModelTextWrap = styled.div`
  margin-right: 8px;
  height: 15px;
  line-height: 1;

  ${mediaTemplates.l} {
    height: 14px;
  }
`;

export const ExpirationDate = styled.div`
  margin-left: 4px;
`;
